import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import BalanceDetail from '../../Component/DashboardOne/BalanceDetail';
import ChartSmallCard from '../../Component/DashboardOne/ChartSmallCard';
import UserDetailcard from '../../Component/DashboardOne/UserDetailcard';
import { fetchDashboard, fetchWalletBalance } from '../../Redux/Actions/dataActions';

function Dashboard({ fetchDashboard, fetchWalletBalance, dashboard, wallet }) {
    useEffect(() => {
        fetchDashboard();
        fetchWalletBalance();
    }, [fetchDashboard, fetchWalletBalance]);

    return (
        <div className='container-xxl'>
            <UserDetailcard />
            <ChartSmallCard dashboardData={dashboard} />
            <BalanceDetail walletData={wallet} dashboardData={dashboard} />
        </div>
    )
}

const mapStateToProps = (state) => ({
    dashboard: state.data?.dashboard,
    wallet: state.data?.dashboard?.data?.wallet || state.data?.wallet,
});

export default connect(mapStateToProps, { fetchDashboard, fetchWalletBalance })(Dashboard);